import { withInstall } from '@tw-element/utils'

import Link from './src/link.vue'

export const TwLink = withInstall(Link)
export default TwLink

export * from './src/link'
